import { createAction } from 'redux-actions'

export const setPageLoaderActive = createAction('PAGE_LOADER/SET_ACTIVE')
